import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import { format } from '~/util/date';

const text = {
  dueDateLabel: 'Update de status voor:',
  automaticallyAcceptanceLabel:
    'Zonder update wordt deze afspraak automatisch in rekening gebracht',
};

type Props = {
  autoAcceptDate: string;
};
const WaitingForFeedback: React.FCC<Props> = ({ autoAcceptDate }) => (
  <JustificationContainer direction="column" gap="xxxs" width="100%">
    <JustificationContainer align="center" gap="xxs">
      <Body size="s" margin={[null]} color={{ group: 'primary' }}>
        {text.dueDateLabel}
      </Body>
      <Body
        size="s"
        margin={[null]}
        fontWeight="semiBold"
        color={{ group: 'primary' }}
      >
        {format(autoAcceptDate, 'dd-MM-yyyy')}
      </Body>
    </JustificationContainer>
    <Body size="s" margin={[null]} color={{ group: 'primary' }}>
      {text.automaticallyAcceptanceLabel}
    </Body>
  </JustificationContainer>
);

export default WaitingForFeedback;
